import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

import { AddQuestionButton } from 'components/simple';

const ProjectQuestionBox = ({
  title,
  description,
  content = null,
  addButtonProps = null,
  titleProps = null,
  titleWrapperProps = null,
  contentProps = null,
}) => (
  <Stack spacing={5} {...contentProps}>
    <Stack spacing={2} {...titleWrapperProps}>
      <Typography variant="h2-bold" component="h3" {...titleProps}>
        {title}
      </Typography>

      {description}
    </Stack>

    {content}

    {addButtonProps && <AddQuestionButton {...addButtonProps} />}
  </Stack>
);

ProjectQuestionBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  content: PropTypes.node,
  addButtonProps: PropTypes.shape({
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  }),
  titleProps: PropTypes.shape({}),
  titleWrapperProps: PropTypes.shape({}),
  contentProps: PropTypes.shape({}),
};
export default ProjectQuestionBox;
